/* Returns same type, although without any undefineds nor nulls. */
export default function removeNulls<In, Out = In>(objectOrArrayOrValue: In): Out {
  if (objectOrArrayOrValue == null) return undefined as Out
  if (objectOrArrayOrValue instanceof Array) return removeNullsFromArrays(objectOrArrayOrValue)
  if (typeof objectOrArrayOrValue === 'object') return removeNullsFromObject(objectOrArrayOrValue)
  return objectOrArrayOrValue as Out
}

function removeNullsFromObject<In extends object, Out>(object: In): Out {
  return Object.fromEntries(
    Object.entries(object)
      .filter(([, value]) => value != null) // using '!=' so it filters both null and undefined out of object
      .map(([key, value]) => [key, removeNulls(value)])
  ) as Out
}

function removeNullsFromArrays<In extends unknown[], Out>(array: In): Out {
  return array
    .filter((value) => value != null) // using '!=' so it filters both null and undefined out of array
    .map((value) => removeNulls(value)) as Out
}
